class SocialFloating extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.classes = {
      activeClass: 'is-active',
      closingClass: 'is-closing'
    };

    this.querySelectorAll('[data-social-toggle]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!theme.config.mqlSmall) return;

    this.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }

  open() {
    this.classList.add(this.classes.activeClass);

    // close promo-popup
    const popup = document.querySelector('promo-popup');
    popup && popup.close();
  }

  close() {
    this.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.classList.remove(this.classes.activeClass);
      this.classList.remove(this.classes.closingClass);
    }, 500);
  }
}
customElements.define('social-floating', SocialFloating);

class PromoPopup extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'beyours:promo-popup';
    this.quizCookieName = 'beyours:promo-popup:quiz';
    this.firstVisitCookieName = 'beyours:promo-popup:first-visit';

    this.classes = {
      bodyClass: 'promo-popup--open',
      activeClass: 'is-active',
      closingClass: 'is-closing',
      showImage: 'show-image'
    };

    this.popup = this.querySelector('.promo-popup');

    // Open modal if errors or success message exist
    if (this.querySelector('.form__message')) {
      this.open();
    }

    this.querySelectorAll('[data-popup-toggle]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    if (!this.getCookie(this.cookieName) || !this.getCookie(this.quizCookieName) || this.dataset.testMode === 'true') {
      this.init();
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);

      document.body.classList.remove(this.classes.bodyClass);
    }
  }
  onSectionLoad(event) {
    filterShopifyEvent(event, this, () => this.open.bind(this));
  }
  onSectionSelect(event) {
    filterShopifyEvent(event, this, this.open.bind(this));
  }
  onSectionDeselect(event) {
    filterShopifyEvent(event, this, this.close.bind(this));
  }

  /**
   * @returns whether cookie banner is visible
   */
  isCookieBannerVisible() {
    const banner = document.getElementById('shopify-pc__banner');
    return banner && window.getComputedStyle(banner).display !== 'none' && banner.offsetHeight > 0;
  }

  init() {
    if(!this.popup) {
      return;
    }
    
    if (Shopify && Shopify.designMode) {
      return;
    }

    if (!this.getCookie(this.firstVisitCookieName)) {
      this.setCookie(this.firstVisitCookieName, this.dataset.expiry, new Date().getTime());
    }

    // after set delay always checks whether cookie consent is visible
    // if not, displays the promo popup
    if (!this.getCookie(this.cookieName)) {
      const checkInterval = parseInt(this.dataset.delay) * 1000;
      const interval = setInterval(() => {
        if (!this.isCookieBannerVisible()) {
          clearInterval(interval);
          this.open();
        }
      }, checkInterval);
    }

    // every minute check if user is on web longer then 20 minutes
    // if so show quiz popup
    if (!this.getCookie(this.quizCookieName)) {
      const quizCheckInterval = 60 * 1000;
      const quizInterval = setInterval(() => {
        const now = new Date().getTime();
        if (
          !this.isCookieBannerVisible() &&
          !this.popup.classList.contains(this.classes.activeClass) &&
          window.location.hash !== '#quiz' &&
          this.getCookie(this.firstVisitCookieName) &&
          now - parseInt(this.getCookie(this.firstVisitCookieName)) >= 20 * 60 * 1000
        ) {
          clearInterval(quizInterval);
          this.initQuizPromo();
        }
      }, quizCheckInterval);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }

  open() {
    document.body.classList.remove(this.classes.bodyClass);
    this.popup.classList.add(this.classes.activeClass);
    setTimeout(() => {
      this.popup.classList.add(this.classes.showImage);
    }, 600);

    if (this.popup.dataset.position === 'center') {
      setScrollbarWidth();
      document.body.classList.add(this.classes.bodyClass);
    }

    // close social-floating
    const social = document.querySelector('social-floating');
    social && social.close();
  }

  close() {
    this.popup.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      this.popup.classList.remove(this.classes.showImage);

      if (this.popup.dataset.position === 'center') {
        document.body.classList.remove(this.classes.bodyClass);
      }
    }, 500);

    // Remove a cookie in case it was set in test mode
    if (this.dataset.testMode === 'true') {
      this.removeCookie(this.cookieName);
      return;
    }

    this.setCookie(this.cookieName, this.dataset.expiry);
  }

  initQuizPromo() {
    const image = this.popup.querySelector('.popup__image img');
    const headline = this.popup.querySelector('.popup__subheading');
    const text = this.popup.querySelector('.popup__text');
    const button = this.popup.querySelector('.button--cta');
    const buttonLabel = button.querySelector('.label');

    headline.innerHTML = 'POTŘEBUJETE PORADIT S VÝBĚREM?';
    text.innerHTML = '<p>Vyplňte náš krátký dotazník a zjistěte, který produkt je pro vás ten pravý.</p>';
    button.href = '/#quiz';
    buttonLabel.innerHTML = 'Přejít na dotazník';
    image.src = 'https://cdn.shopify.com/s/files/1/0837/2181/4281/files/products_banner.jpg?v=1757664747';
    image.removeAttribute('srcset');

    this.open();
    this.setCookie(this.quizCookieName, this.dataset.expiry);
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry, val = 'true') {
    document.cookie = `${name}=${val}; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('promo-popup', PromoPopup);
